const register = () => {
  // register phase
};

export default register;
